import React, { Component } from 'react';
import { connect } from 'react-redux';

class Chromecast extends Component{
    constructor(props){
        super(props)
    }

    render(){
        return(
            <h2>OK</h2>
        )
    }
}



    const mapStateToProps = (state,ownProps) =>{
        return {
          channel: state.channel,
          ownProps
        }
      }
    export default connect(mapStateToProps)(Chromecast);



// WEBPACK FOOTER //
// ./src/chromecast.js